import './../stylesheets/actiontext';
import './../stylesheets/events';

import * as carouselComponent from './components/carousel';
import * as articleComponent from './components/article';
import * as municipalityComponent from './components/municipality';
import * as fieldComponent from './components/field';
import * as fileFieldComponent from './components/file_field';
import * as searchComponent from './components/search';
import * as callapseComponent from './components/collapse';
import * as formComponent from './components/form';
import * as holdPeriodComponent from './components/hold_period';

// ページ読み込み時の処理
document.addEventListener('turbolinks:load', function() {
  // メインカルーセル
  carouselComponent.syncingCarousel();
  // 記事のアクション
  articleComponent.addPublishedPeriodLabelRequired();
  articleComponent.addRecruitmentPeriodLabelRequired();
  articleComponent.selectPublishedPeriodType();
  articleComponent.selectRecruitmentPeriodType();
  articleComponent.blockOldLink();
  // 開催地のアクション
  municipalityComponent.municipalityAllSelect();
  municipalityComponent.municipalityAllRelease();
  municipalityComponent.municipalityCustom();
  // 分野のアクション
  fieldComponent.fieldAllSelect();
  fieldComponent.fieldAllRelease();
  fieldComponent.fieldCustom();
  // ファイルフィールドのアクション
  fileFieldComponent.selectFileFieldActions();
  fileFieldComponent.selectFileAfterActions();
  fileFieldComponent.cancelSelectFile();
  fileFieldComponent.destroySelectFile();
  // 詳細検索のアクション
  searchComponent.submitAction();
  searchComponent.ajaxSearchGroupResult();
  searchComponent.stopPagenationSubmitAction();
  // アコーディオンのアクション
  callapseComponent.toggleCollapse();
  // フォームのアクション
  formComponent.temporarilySave();
  // 開催期間のアクション
  holdPeriodComponent.addHoldPeriodButton();
  holdPeriodComponent.deleteHoldPeriodButton();
  holdPeriodComponent.selectHoldPeriodType();
  // 開催方法のプレビュー
  holdingMethodPreview();
})

// 開催方法のプレビュー
export function holdingMethodPreview () {
  // プレビューボタン
  let holdingMethodPreviewButton = document.getElementById('holding_method_preview_button');
  if (!!holdingMethodPreviewButton) {
    holdingMethodPreviewButton.addEventListener('click', function(event) {
      holdingMethodPreviewAction();
    });
  }

  // タイトル変更
  let title = document.getElementById('event_title');
  if (!!title) {
    title.addEventListener('change', function(event) {
      // プレビューの存在
      let previewElement = document.getElementById('holding_method_preview');
      if (!!previewElement) {
        holdingMethodPreviewAction();
      }
    });
  }

  // 開催方法変更
  let holdingMethods = document.getElementsByName('event[holding_method]');
  for (let i = 0; i < holdingMethods.length; i++) {
    if (!!holdingMethods[i]) {
      holdingMethods[i].addEventListener('change', function(event) {
        // プレビューの存在
        let previewElement = document.getElementById('holding_method_preview');
        if (!!previewElement) {
          holdingMethodPreviewAction();
        }
      });
    }
  }

  // 開催地変更
  let selectMunicipalities = document.querySelectorAll('[id^=event_municipality_ids]')
  for (let i = 0; i < selectMunicipalities.length; i++) {
    if (!!selectMunicipalities[i]) {
      selectMunicipalities[i].addEventListener('change', function(event) {
        // プレビューの存在
        let previewElement = document.getElementById('holding_method_preview');
        if (!!previewElement) {
          holdingMethodPreviewAction();
        }
      });
    }
  }

  // 開催地の全選択
  let municipalityAllSelect = document.getElementById('municipality_all_select');
  if (!!municipalityAllSelect) {
    municipalityAllSelect.addEventListener('click', function(event) {
      // プレビューの存在
      let previewElement = document.getElementById('holding_method_preview');
      if (!!previewElement) {
        holdingMethodPreviewAction();
      }
    });
  }

  // 開催地の全解除
  let municipalityAllRelease = document.getElementById('municipality_all_release');
  if (!!municipalityAllRelease) {
    municipalityAllRelease.addEventListener('click', function(event) {
      // プレビューの存在
      let previewElement = document.getElementById('holding_method_preview');
      if (!!previewElement) {
        holdingMethodPreviewAction();
      }
    });
  }
}

// 開催方法を追加
function holdingMethodPreviewAction () {
  // プレビューボタン
  let holdingMethodPreviewButton = document.getElementById('holding_method_preview_button');
  // タイトル
  let title = document.getElementById('event_title').value;
  // 選択された開催方法
  let selectHoldingMethod = document.querySelector("input[name='event[holding_method]']:checked");
  // 選択された開催地
  let selectMunicipalities = document.querySelectorAll('[id^=event_municipality_ids]:checked')
  // 開催地
  let selectMunicipalityWord = '';
  if (selectHoldingMethod.value == 'online_and_face_to_face_outside') {
    selectMunicipalityWord = '[県外]';
  } else if (selectMunicipalities.length == 1) {
    selectMunicipalityWord = '[' + selectMunicipalities[0].nextElementSibling.innerText + ']';
  } else if (selectMunicipalities.length == 19) {
    selectMunicipalityWord = '[県内全域]';
  } else if (selectMunicipalities.length > 1) {
    selectMunicipalityWord = '[県内複数地域]';
  }
  // divを生成
  let box = document.createElement('div');
  box.setAttribute('id', 'holding_method_preview');
  box.classList.add('col-12');

  // badgeを生成
  let span = document.createElement('span');
  span.classList.add('badge', 'badge-dark', 'mb-2');
  span.innerHTML = 'ホーム画面に表示される内容のサンプル';

  // リストを生成
  let dl = document.createElement('dl');
  dl.classList.add('base-list');

  // 日付
  let dtDate = document.createElement('dt');
  dtDate.classList.add('float-left');
  dtDate.innerHTML = 'xx.xx.xx';

  // 開催期間
  let dtRange = document.createElement('dt');
  dtRange.classList.add('mx-1', 'float-left');
  dtRange.innerHTML = '(開催期間: xxxx/xx/xx - xxxx/xx/xx)';

  // 開催地
  let ddMunicipality = document.createElement('dt');
  ddMunicipality.classList.add('mx-1', 'float-left');
  ddMunicipality.innerHTML = selectMunicipalityWord;

  // 開催方法
  let dtHoldingMethod = document.createElement('dt');
  if (selectHoldingMethod.value != 'face_to_face_only' && selectHoldingMethod.value != 'local') {
    let badgeHoldingMethod = document.createElement('span');
    badgeHoldingMethod.classList.add('badge', 'badge-danger');
    badgeHoldingMethod.innerHTML = selectHoldingMethod.parentElement.innerText;
    dtHoldingMethod.appendChild(badgeHoldingMethod);
  }

  // タイトル
  let ddTitle = document.createElement('dd');
  ddTitle.classList.add('clearfix', 'ml-3');
  // リンク
  let aTitle = document.createElement('a');
  aTitle.href = 'javascript:void(0)';
  if (!!title) {
    aTitle.innerHTML = title;
  } else {
    aTitle.innerHTML = 'XXXXXXXXXXXXXXXXXXXXXXXXXXX';
  }
  // タイトル < リンク
  ddTitle.appendChild(aTitle);

  // リスト < 日付
  dl.appendChild(dtDate);
  // リスト < 開催期間
  dl.appendChild(dtRange);
  // リスト < 開催地
  if (selectHoldingMethod.value != 'online_only') {
    dl.appendChild(ddMunicipality);
  }
  // リスト < 開催方法
  dl.appendChild(dtHoldingMethod);
  // リスト < タイトル
  dl.appendChild(ddTitle);
  // div < span
  box.appendChild(span);
  // div < リスト
  box.appendChild(dl);

  // リストを画面に追加
  let target = holdingMethodPreviewButton.closest('.row');
  let previewElement = document.getElementById('holding_method_preview');
  if (!!previewElement) {
    // リストを差し替え
    previewElement.replaceWith(box);
  } else {
    // リストを追加
    target.appendChild(box);
  }
}